import React from 'react';
import tpl from '../templates/public_contracts';
import BaseNewCardView from './../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    static displayName = 'PublicContracts';
}
